import { useQueryClient } from '@tanstack/react-query';

import { useParticipantPersonBlockEventsApi } from '@/features/api/hooks/participant-person-block-events/useParticipantPersonBlockEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';
import { invalidateChatCachesForPerson } from '@/features/api/utils/chatCaches';
import { invalidateGroupCachesForPerson } from '@/features/api/utils/groupCaches';
import { invalidatePostCachesForPerson } from '@/features/api/utils/postCaches';

export const useBlockPerson = () => {
  const queryClient = useQueryClient();
  const api = useParticipantPersonBlockEventsApi();

  return useApiMutation({
    mutationFn: async (personId: string) => {
      await api.personBlockRequest({ clientPersonBlockRequest: { personId } });
      return personId;
    },
    onSuccess: (personId) => {
      invalidatePostCachesForPerson(queryClient, personId);
      invalidateGroupCachesForPerson(queryClient, personId);
      invalidateChatCachesForPerson(queryClient, personId);
    }
  });
};
